import { Field } from './Field';
import { IRangeField } from './IRangeField';
import { ComparisonType } from './ComparisonType';

export class BatesRangeField extends Field implements IRangeField<String> {

  public begin: String;
  public end: String;

  constructor(name: string, description: string, begin: String = null, end: String = null, comparisonType: ComparisonType = null) {
    super(name, description, BatesRangeField.typeName(), comparisonType);
    this.begin = begin;
    this.end = end;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.BatesRangeField";
  }
}
